import gql from 'graphql-tag';

import client from '../graphqlAPI';

const POST_ADD_TICKET_MUTATION = gql`
  mutation Post(
    $date: String
    $description: ObjectLocalizationInput
    $price: Float
    $currency: String
    $sellers: [SellerTicketInput]
    $show: Boolean
    $showFee: Boolean
    $showPastEndDate: Int
    $ticketName: String
    $ticketReadableName: ObjectLocalizationInput
    $subtitle: ObjectLocalizationInput
    $ticketSlugName: String!
    $purchaseUrl: String,
    $status: TicketStatus,
    $tags: [String]
    $venueSlugName: String
  ) {
    postAddTicket(
      date: $date
      description: $description
      subtitle: $subtitle
      price: $price
      currency: $currency
      sellers: $sellers
      show: $show
      showFee: $showFee
      showPastEndDate: $showPastEndDate
      ticketName: $ticketName
      ticketReadableName: $ticketReadableName
      ticketSlugName: $ticketSlugName
      purchaseUrl: $purchaseUrl,
      status: $status,
      tags: $tags,
      venueSlugName: $venueSlugName,
    ) {
      isAuth
      isAdded
      ticketSlugName
    }
  }
`;

const postAddTicket = async ({
  date, description, price, sellers, show, showFee, showPastEndDate, ticketName, ticketReadableName, ticketSlugName, currency, purchaseUrl, status, tags, subtitle, venueSlugName,
}) => {
  try {
    const result = await client
      .mutate({
        mutation: POST_ADD_TICKET_MUTATION,
        variables: {
          date,
          subtitle,
          description,
          price,
          currency,
          sellers,
          show,
          showFee,
          showPastEndDate,
          ticketName,
          ticketReadableName,
          ticketSlugName,
          purchaseUrl,
          status,
          tags,
          venueSlugName,
        },
        fetchPolicy: 'no-cache',
      })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const {
      data: { postAddTicket: postAddTicketValidationData },
    } = result;

    if (postAddTicketValidationData) {
      return postAddTicketValidationData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: postAddTicketValidationData = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: postAddTicket Error: ${error}`);
    return null;
  }
};

export default postAddTicket;
